export default __webpack_public_path__ + "static/media/captcha.8e9dcce2.jpg";